import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Grid,
  Typography,
  Divider,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card
} from '@mui/material';
import {
  Phone,
  Mail,
  LocationOn,
  CheckCircle,
  BarChart,
  InsertDriveFile,
  PictureAsPdf
} from '@mui/icons-material';
import axios from 'axios';
import html2pdf from 'html2pdf.js';
import logo from '../Images/logo-dark.png'
import logospg from '../Images/LOGO_SPG.png'
import { BeatLoader } from 'react-spinners';
import dayjs from "dayjs";
import Cookies from 'js-cookie';
const Invoice = () => {
  const [InvoiceData, setInvoiceData] = useState();
  const invoiceRef = useRef();
  const userinfo = JSON.parse(Cookies.get('user-info'));
  const urlParams = new URLSearchParams(window.location.search);
  const Id = urlParams.get('id');
  const [loader,setloader] = useState(false);
  const getInvoiceData = async () => {
    setloader(true)
    try {
      const config2 = {
        headers: {
          Authorization:
            'gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ=='
        }
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL2}/apiV1/user-invoice/?user_id=${userinfo.id}&id=${Id}`,
        config2
      );
      if (response.status === 200) {
        setInvoiceData(response.data);
        setloader(false);
      }
    } catch (err) {
      console.log(err?.response?.data?.message);
      setloader(false);
    }
  };

  const handleDownloadPDF = () => {
    const element = invoiceRef.current;
    const opt = {
      margin: 0,
      filename: `Invoice-${InvoiceData?.invoice_number || 'Download'}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        ignoreElements: (element) => {
          return element.classList?.contains("no-print");
        }
      },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    html2pdf().set(opt).from(element).save();
  };


  useEffect(() => {
    getInvoiceData();
  }, [Id]);

  return (
    <>
    {loader && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        width: "100vw",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        zIndex: 9999,
                    }}
                >
                    <BeatLoader color=" #07659c" size={20} />
                </Box>
            )}
     <Box mx="auto" p={{ xs: 2, sm: 3 }}>
      <Card sx={{ p: { xs: 2, sm: 4 } }} ref={invoiceRef}>
        {/* Header Section */}
        <Grid container spacing={2} alignItems="center" justifyContent="space-between" mb={2}>
          {/* Left: Company Info */}
          <Grid item xs={12} md={4}>
              <img src={logospg} alt="Logo" style={{ width: 120, maxWidth: '100%' }} /> 
            <Typography fontWeight={600}>
           {InvoiceData?.configuration__company_name}
            </Typography>
            <Box display="flex" gap={1} alignItems="start">
              {/* <LocationOn fontSize="small" color="action" /> */}
              <Box>
                <Typography variant="body2">{InvoiceData?.configuration__address_line_1}</Typography>
                <Typography variant="body2">{InvoiceData?.configuration__address_line_2}</Typography>
              </Box>
            </Box>
            <Box display="flex" gap={1} alignItems="center">
              {/* <Mail fontSize="small" color="action" /> */}
              <Typography variant="body2">
                {InvoiceData?.configuration__company_email}
              </Typography>
            </Box>
            <Box display="flex" gap={1} alignItems="center">
              {/* <Phone fontSize="small" color="action" /> */}
              <Typography variant="body2">{InvoiceData?.configuration__mobile_no}</Typography>
            </Box>
          </Grid>

          {/* Center: Logo */}
          <Grid item xs={12} md={4} textAlign="center">
            <Box mb={1}>
              <img src={logo} alt="Logo" style={{ width: 130, maxWidth: '100%' }} />
            </Box>
            <Typography variant="h5" fontWeight={700}>
              Invoice
            </Typography>
          </Grid>

          {/* Right: Invoice Details */}
          <Grid item xs={12} md={4} textAlign={{ xs: 'left', md: 'right' }}>
            <Typography variant="body2">
              <strong>Invoice Number:</strong> {InvoiceData?.invoice_number}
            </Typography>
            <Typography variant="body2">
              <strong>Date:</strong>{" "}
              {InvoiceData?.date
                              ? dayjs(InvoiceData.date).format("MM-DD-YYYY")
                              : '--'}
            </Typography>
          </Grid>
        </Grid>

        {/* Customer Information */}
        <Box border="2px solid rgb(239, 239, 241)" borderRadius={1} p={2} mb={4}>
          <Typography variant="h6" fontWeight={600} textAlign="center" mb={2}>
            Customer Information
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="body2">Company Name :</Typography>
              <Typography variant="body2">Contact Name :</Typography>
              <Typography variant="body2">Email Id :</Typography>
              <Typography variant="body2">Address :</Typography>
              <Typography variant="body2">Phone :</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body2">{InvoiceData?.customer__company_name || '—'}</Typography>
              <Typography variant="body2">{InvoiceData?.customer__full_name || '—'}</Typography>
              <Typography variant="body2">{InvoiceData?.customer__corp_email || '—'}</Typography>
              <Typography variant="body2">
                {(InvoiceData?.customer_add_info?.[0]?.address_line_1 || '—') +
                  (InvoiceData?.customer_add_info?.[0]?.city ? `, ${InvoiceData.customer_add_info[0].city}` : '') +
                  (InvoiceData?.customer_add_info?.[0]?.postal_code ? `, ${InvoiceData.customer_add_info[0].postal_code}` : '')}
              </Typography>
              <Typography variant="body2">{InvoiceData?.customer_add_info?.[0]?.phone_number || '—'}</Typography>
            </Grid>
          </Grid>
        </Box>

        {/* Billing Table */}
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#004466' }}>
                <TableCell sx={{ color: '#fff' }}>S.NO</TableCell>
                <TableCell sx={{ color: '#fff' }}>PLAN TYPE</TableCell>
                <TableCell sx={{ color: '#fff' }}>DESCRIPTION</TableCell>
                <TableCell sx={{ color: '#fff' }} align="center">QUANTITY</TableCell>
                <TableCell sx={{ color: '#fff' }} align="center">UNIT PRICE</TableCell>
                <TableCell sx={{ color: '#fff' }} align="right">PRICE</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>

              {/* MAIN LINE ITEM */}
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>{InvoiceData?.billing_info?.[0]?.item_name}</TableCell>
                <TableCell>
                  A Plan with {InvoiceData?.billing_info?.[0]?.no_of_projects_allowed} projects
                </TableCell>
                <TableCell align="center">
                  {InvoiceData?.billing_info?.[0]?.no_of_projects_allowed}
                </TableCell>
                <TableCell align="center">
                  $
                  {(InvoiceData?.billing_info?.[0]?.actual_amount /
                    InvoiceData?.billing_info?.[0]?.no_of_projects_allowed).toFixed(2)}
                </TableCell>
                <TableCell align="right">
                  ${InvoiceData?.billing_info?.[0]?.actual_amount}
                </TableCell>
              </TableRow>

              {/* SUMMARY SECTION */}
              <TableRow>
                <TableCell colSpan={6} sx={{ borderBottom: "none", paddingBottom: 0 }}>

                  <Box
                    sx={{
                      width: "320px",
                      ml: "auto",
                      mt: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: 1
                    }}
                  >

                    {/* TAX */}
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography sx={{ fontWeight: 500 }}>
                        Tax ({InvoiceData?.tax_info?.tax_percent}%)
                      </Typography>
                      <Typography>
                        ${InvoiceData?.tax_info?.tax_price.toFixed(2)}
                      </Typography>
                    </Box>

                    {InvoiceData?.is_promo_code === true && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 1
                        }}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "13px",
                              display: "flex",
                              alignItems: "center",
                              gap: "2px",
                            }}
                          >
                            Discount {' '}

                          (  <Box
                              sx={{
                                fontSize: "11px",
                                color: "#0a7d0a",
                                // backgroundColor: "#e7ffeb",
                                // padding: "2px 8px",
                                // borderRadius: "6px",
                                fontWeight: 600,
                              }}
                            >
                              {InvoiceData?.billing_info?.[0]?.sub_promo_code}
                            </Box>

                          
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#444"
                              }}
                            >
                              / {InvoiceData?.billing_info?.[0]?.promo_discount_value}%
                            </Typography>)
                          </Typography>
                        </Box>

                        {/* RIGHT SIDE — AMOUNT */}
                        <Typography sx={{ fontWeight: 600, fontSize: "13px" }}>
                          -${InvoiceData?.billing_info?.[0]?.sub_promo_discount_amount}
                        </Typography>
                      </Box>
                    )}


                    {/* GRAND TOTAL */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 1,
                        borderTop: "1px solid #ddd",
                        pt: 1
                      }}
                    >
                      <Typography sx={{ fontWeight: 700 }}>GRAND TOTAL</Typography>
                      <Typography sx={{ fontWeight: 700 }}>
                        ${InvoiceData?.total_amount.toFixed(2)}
                      </Typography>
                    </Box>

                  </Box>

                </TableCell>
              </TableRow>

            </TableBody>
          </Table>




        {/* Thank You */}
        <Box
          textAlign="center"
          bgcolor="primary.lighter"
          borderRadius={2}
          mt={4}
          py={2}
          px={1}
        >
          <Typography variant="h6" color="primary.dark">
            Thank You for Your Purchase!
          </Typography>
        </Box>

        {/* Download Button */}
        <Box display="flex" gap={2} justifyContent="center" mt={3}>
          <Button
            startIcon={<PictureAsPdf />}
            variant="contained"
            color="inherit"
            className="no-print button2"
            onClick={handleDownloadPDF}
          >
            Download PDF
          </Button>
        </Box>
      </Card>
    </Box></>

  );
};

export default Invoice;
